import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["testId"];
import React from 'react';
import { messages } from '../../../../../../messages';
import Text from '../../../elements/text';
import Block from '../../block';
export var RelatedUrlsBlockErroredView = function RelatedUrlsBlockErroredView(_ref) {
  var testId = _ref.testId,
    blockProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Block, _extends({}, blockProps, {
    testId: testId
  }), /*#__PURE__*/React.createElement(Text, {
    message: {
      descriptor: messages.generic_error_message
    }
  }));
};